import { cn } from '@/lib/utils'

export type ButtonVariant = 'primary' | 'accent' | 'secondary' | 'ghost' | 'danger'
export type ButtonSize = 'sm' | 'md' | 'lg'

const VARIANTS: Record<ButtonVariant, string> = {
  primary:
    'bg-[var(--color-brand-accent)] text-[var(--accent-ink)] hover:bg-[#5cefff] hover:shadow-[0_8px_28px_-6px_rgba(0,229,255,0.55)]',
  accent:
    'bg-[var(--color-brand-accent)] text-[var(--accent-ink)] shadow-[0_0_0_1px_rgba(0,229,255,0.4),0_10px_36px_-10px_rgba(0,229,255,0.5)] hover:-translate-y-px hover:shadow-[0_0_0_1px_rgba(0,229,255,0.6),0_14px_48px_-8px_rgba(0,229,255,0.65)]',
  secondary:
    'border border-[var(--surface-border-strong)] bg-[var(--surface-raised)] text-[var(--text-strong)] hover:border-[var(--color-brand-accent)]/50 hover:bg-[var(--surface-card-hover)]',
  ghost: 'bg-transparent text-[var(--text-strong)] hover:bg-white/[0.06]',
  danger: 'bg-red-700 text-white hover:bg-red-600',
}

const SIZES: Record<ButtonSize, string> = {
  sm: 'min-h-9 px-3 text-sm',
  md: 'min-h-11 px-4 text-sm',
  lg: 'min-h-14 px-6 text-base',
}

export function buttonClassName({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className,
}: {
  variant?: ButtonVariant
  size?: ButtonSize
  fullWidth?: boolean
  className?: string
} = {}) {
  return cn(
    'inline-flex items-center justify-center gap-2 rounded-xl font-semibold no-underline transition-[color,background-color,border-color,box-shadow,transform] duration-200',
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-brand-accent-readable)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--surface-bg)]',
    'disabled:cursor-not-allowed disabled:opacity-50 aria-disabled:cursor-not-allowed aria-disabled:opacity-50',
    VARIANTS[variant],
    SIZES[size],
    fullWidth && 'w-full',
    className,
  )
}
